export class CloudStandard {
    public static LITTLE_CLOUD: number = 50;
    public static MANY_CLOUD: number = 80;
}